export default "__VITE_ASSET__ysP3Pz73__"